<script setup lang="ts">
import { ref } from 'vue';
import ReviewForm, { type ReviewFormValues } from './ReviewForm.vue';
import type { ExpertData } from './ExpertDetailsCard.vue';
import { useSubmitPublicReview } from '@/app/composables/reviews/useSubmitPublicReview';

const props = withDefaults(defineProps<{
    token: string;
    expert: ExpertData;
    showCloseButton?: boolean;
}>(), {
    showCloseButton: false,
});

const emit = defineEmits<{
    success: [];
    cancel: [];
}>();

const formRef = ref<InstanceType<typeof ReviewForm> | null>(null);

// Submit review mutation
const { submitReview, isSubmitting, isSuccess } = useSubmitPublicReview();

// Handle form submission
const handleSubmit = async (values: ReviewFormValues) => {
    try {
        await submitReview({
            token: props.token,
            quality: values.quality,
            communication: values.communication,
            timelines: values.timelines,
            value_for_money: values.value_for_money,
            review_text: values.review_text,
            is_anonymous: values.is_anonymous,
        });
        emit('success');
    } catch (error) {
        console.error('[SubmitPublicReviewForm] Submit error:', error);
    }
};

const handleCancel = () => {
    emit('cancel');
};

// Reset form
const resetForm = () => {
    formRef.value?.resetForm();
};

defineExpose({ resetForm });
</script>

<template>
    <ReviewForm
        ref="formRef"
        :expert="expert"
        :show-close-button="showCloseButton"
        :is-submitting="isSubmitting"
        :is-success="isSuccess"
        @submit="handleSubmit"
        @cancel="handleCancel"
    />
</template>

